var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"chart-wrap"},[_c('Chart',{ref:"chart",attrs:{"id":("chart_" + _vm.chartId),"height":(_vm.dataList.length * 20 < 300 ? 300 : _vm.dataList.length * 20) + 'px',"width":"100%","options":_vm.option}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }